import React from 'react';

const flashpointsData = [
    { "region": "WESTERN NORTH", "no_of_flashpoints": 297 },
    { "region": "WESTERN", "no_of_flashpoints": 374 },
    { "region": "VOLTA", "no_of_flashpoints": 578 },
    { "region": "UPPER WEST", "no_of_flashpoints": 347 },
    { "region": "UPPER EAST", "no_of_flashpoints": 413 },
    { "region": "SAVANNAH", "no_of_flashpoints": 74 },
    { "region": "OTI", "no_of_flashpoints": 459 },
    { "region": "NORTHERN", "no_of_flashpoints": 837 },
    { "region": "NORTH EAST", "no_of_flashpoints": 162 },
    { "region": "GREATER ACCRA", "no_of_flashpoints": 1430 },
    { "region": "EASTERN", "no_of_flashpoints": 903 },
    { "region": "CENTRAL", "no_of_flashpoints": 1209 },
    { "region": "BONO EAST", "no_of_flashpoints": 460 },
    { "region": "BONO", "no_of_flashpoints": 272 },
    { "region": "ASHANTI", "no_of_flashpoints": 2170 },
    { "region": "AHAFO", "no_of_flashpoints": 249 }
];

const FlashpointStats = () => {
    // Sort data in descending order by flashpoints
    const sortedData = [...flashpointsData].sort((a, b) =>
        b.no_of_flashpoints - a.no_of_flashpoints
    );

    // Color intensity function
    const getColorIntensity = (value: number, maxValue: number) => {
        if (value <= 0) return "bg-red-100"; // Lowest intensity
        if (value >= maxValue) return "bg-red-900 text-white"; // Highest intensity

        const intensity = Math.min((value / maxValue) * 100, 100);
        const step = Math.ceil((intensity / 100) * 9); // Map 0-100 to 1-9
        return `bg-red-${step}00`; // Return Tailwind class
    };
    const maxFlashpoints = Math.max(...flashpointsData.map(item => item.no_of_flashpoints));

    return (
        <div className=" bg-white shadow-lg">
            <div className="bg-red-600 text-white p-4">
                <h2 className="text-lg font-bold">Regional Flashpoints</h2>
            </div>

            <div className="divide-y divide-gray-200">
                {sortedData.map((item, index) => (
                    <div
                        key={item.region}
                        className={`p-4 flex justify-between items-center ${getColorIntensity(item.no_of_flashpoints, maxFlashpoints)}`}
                    >
                        <div>
                            <h3 className="font-bold">{item.region}</h3>
                        </div>
                        <div className="flex items-center">
              <span className=" font-semibold mr-2">
                {item.no_of_flashpoints.toLocaleString()}
              </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FlashpointStats;